import React, { useState, useEffect } from "react";
import delay from "lodash/delay";
import { useDispatch } from "react-redux";
import { Icon } from "components/SvgIcons";
import { madeItRecipe } from "store/collectionReducer/collectionActions";
import { isUserLogin } from "store/loginReducer";
import {
  MadeInButtonContainer,
  CheckWrap,
  UndoWrap,
  TextWrap,
  MadeText,
  Description,
  CountText,
  MadeItContent,
  Tooltip,
} from "./styled";
import { useSelector } from "react-redux";

const MOBILE_COUNT_STYLE_DELAY = 500;
const WAIT_FOR_UPDATES_DELAY = 300;

export const getTimesMessage = (count) => {
  return `${count} ${count == 1 || count == 0 ? "time" : "times"}`;
};

const MadeItButton = ({ madeIt, recipeId, isMobile, canMadeIt }) => {
  const [waitForUpdates, setWaitForUpdates] = useState(false);
  const [madeHover, setMadeHover] = useState(false);
  const [undoHover, setUndoHover] = useState(false);
  const dispatch = useDispatch();

  const isLogin = useSelector(isUserLogin);

  useEffect(() => {
    delay(() => setWaitForUpdates(false), WAIT_FOR_UPDATES_DELAY);
  }, [madeIt]);

  const updateMadeIt = (made_times) => {
    if (!waitForUpdates) {
      dispatch(madeItRecipe({ recipe: recipeId, made_times }));
      setWaitForUpdates(true);
    }
  };

  const increaseMadeIt = () => canMadeIt && updateMadeIt(1);
  const decreaseMadeIt = () => canMadeIt && updateMadeIt(-1);

  const onDesktopHover = (el, isHover) => {
    if (!isMobile && canMadeIt) {
      const setHover = el == "made" ? setMadeHover : setUndoHover;
      setHover(isHover);
    }
  };

  const onMobileTouch = (el, isTouch) => {
    if (isMobile && canMadeIt) {
      const setHover = el == "made" ? setMadeHover : setUndoHover;
      if (isTouch) {
        setHover(true);
      } else {
        delay(() => setHover(false), MOBILE_COUNT_STYLE_DELAY);
      }
    }
  };

  const madeCount = isMobile ? madeIt : madeHover ? madeIt + 1 : undoHover ? madeIt - 1 : madeIt;

  return (
    <MadeInButtonContainer>
      <MadeItContent
        onClick={increaseMadeIt}
        className={madeHover ? "hover" : ""}
        onMouseEnter={() => onDesktopHover("made", true)}
        onMouseLeave={() => onDesktopHover("made", false)}
        onTouchStart={() => onMobileTouch("made", true)}
        onTouchEnd={() => onMobileTouch("made", false)}
      >
        <CheckWrap>
          <Icon icon="check" />
        </CheckWrap>
        <TextWrap>
          <MadeText>{madeIt > 0 ? "Make it again!" : "Made it!"}</MadeText>
          {madeIt > 0 ? (
            <Description>
              I made it &nbsp;
              <CountText madeHover={madeHover} undoHover={undoHover}>
                {getTimesMessage(madeCount)}
              </CountText>
            </Description>
          ) : null}
        </TextWrap>
      </MadeItContent>
      {madeIt > 0 ? (
        <UndoWrap
          onClick={decreaseMadeIt}
          className={undoHover ? "hover" : ""}
          onMouseEnter={() => onDesktopHover("undo", true)}
          onMouseLeave={() => onDesktopHover("undo", false)}
          onTouchStart={() => onMobileTouch("undo", true)}
          onTouchEnd={() => onMobileTouch("undo", false)}
        >
          <Icon icon="undo" />
        </UndoWrap>
      ) : null}
      {!isLogin && <Tooltip>Log In to mark as Made</Tooltip>}
    </MadeInButtonContainer>
  );
};

export default MadeItButton;
